import React from 'react';
import { WithIcon } from './WithIcon';

export const IconClose = WithIcon(
  'Close',
  '0 0 1024 1024',
  <path
    transform="scale(1, -1) translate(0, -960)"
    d="M132.422 784.297l43.416 43.416 715.868-715.868-43.416-43.416-715.868 715.868zM132.422 111.703l715.868 715.868 43.416-43.416-715.868-715.868-43.416 43.416z"
  />
);
